/* @ngInject */
const myTrainDisplay = (
  utils
) => {
  return {
    restrict: 'E',
    scope: {
      myTrain: '=',
      myWagons: '=?',
      enableButtons: '=?',
      enableTitle: '=?',
      enableBack: '=?',
    },

    template: require('./myTrainDisplay.html'),

    /* @ngInject */
    controller: (
      $scope
    ) => {
      $scope.utils = utils
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myTrainDisplay



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/train/directives/display/myTrainDisplay.js